import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useHistory, useParams } from 'react-router-dom'

import { deleteContact } from './redux/actions'
import { ApplicationState } from 'AppReducer'

type ContOpts = { person?: number, hideEmpty?: boolean, disableActions?: boolean }

const ContactList: React.FC<ContOpts> = ({ person, hideEmpty = false, disableActions = false }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { personId: routePerson } = useParams<{ personId: string }>()
  const { contacts } = useSelector((state: ApplicationState) => state.userContactReducer)

  const personId = routePerson || person

  function handleRemove (id: number): void {
    if (personId && window.confirm('Tem certeza que deseja remover?')) {
      deleteContact(personId, id)(dispatch).then(res => {
        if (res?.status === 'success') {
          history.push(person ? '/panel/profile' : `/panel/person/${personId}/contact`)
        }
      })
    }
  }

  if (hideEmpty && !contacts.length) {
    return null
  }

  return (
    <div className="row justify-start margin-top-32">
      <h2>Contatos Cadastrados</h2>
      {
        contacts.length === 0 &&
        <p className="row empty">Nenhum contato cadastrado</p>
      }

      {
        contacts.map(contact => (
          <div className="row tile" key={contact.id}>
            <div className="grow">
              <div className="row">
                <div className="row col-6">
                  <p className="col-12 bold">Tipo</p>
                  <p className="col-12 no-margin">{ contact.type }</p>
                </div>
                <div className="row col-6">
                  <p className="col-12 bold">Número</p>
                  <p className="col-12 no-margin">{ contact.value }</p>
                </div>
              </div>
            </div>
            {
              !disableActions &&
              <>
                <span
                  style={{ width: 48 }}
                  onClick={(): void => handleRemove(contact.id)}
                  className="button remove margin-right-8"
                >
                  <i className="fa fa-trash"/>
                </span>
                <NavLink
                  style={{ width: 48 }}
                  className="button primary"
                  to={
                    person
                      ? `/panel/profile/contact/${contact.id}/edit`
                      : `/panel/person/${personId}/contact/${contact.id}/edit`
                  }
                >
                  <i className="fa fa-edit"/>
                </NavLink>
              </>
            }
          </div>
        ))
      }
    </div>
  )
}

export default ContactList
